import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import ModalActions from '~redux/Modal/actions';
import AuthActions from '~redux/Auth/actions';
import { setAuthHeader } from '~config/api';
import { MODALS } from '~redux/Modal/constants';
import LocalStorageService from '~services/LocalStorageService';

export function useAuth() {
  const dispatch = useDispatch();
  const location = useLocation().search;
  const params = new URLSearchParams(location);
  const authToken = params.get('auth_token');

  useEffect(() => {
    if (!authToken) {
      return;
    }

    const successBehavior = () => {
      setAuthHeader(authToken);
      LocalStorageService.setAccessToken(authToken);
      LocalStorageService.removeGuestUser();
      LocalStorageService.removeProfile();
      LocalStorageService.removeLoginEmail();
    };
    const failureBehavior = () => dispatch(ModalActions.openModal(MODALS.LOGIN));
    dispatch(AuthActions.getCurrentUser(successBehavior, failureBehavior, authToken));
  }, [authToken, dispatch]);
}
